function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.819 11.551C38.8194 9.30275 38.1637 7.10324 36.9321 5.22232C35.7005 3.34139 33.9467 1.86083 31.8858 0.96226C29.8249 0.0636905 27.5466 -0.213807 25.3303 0.163798C23.114 0.541403 21.056 1.5577 19.409 3.08801C18.2823 2.03849 16.9572 1.22486 15.5114 0.694972C14.0657 0.165087 12.5287 -0.0703536 10.9906 0.00249713C9.45259 0.0753478 7.94466 0.45502 6.55551 1.11918C5.16635 1.78334 3.92399 2.71859 2.90158 3.8699C1.87916 5.02121 1.09729 6.36534 0.601954 7.82325C0.106613 9.28116 -0.0921836 10.8234 0.0172368 12.3593C0.126657 13.8951 0.542079 15.3936 1.2391 16.7666C1.93612 18.1395 2.90064 19.3593 4.07595 20.354L19.409 34.841L34.742 20.356C36.021 19.2731 37.0484 17.9243 37.7525 16.4036C38.4567 14.8829 38.8206 13.2268 38.819 11.551Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 38.819,
  height: 34.839,
  fill: "white"
})));

var SvgHeartSmall = function SvgHeartSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-small.0e96a0b3.svg";
export { ForwardRef as ReactComponent };